import React from 'react'

interface SplitCalloutProps {
  additionalClasses?: string
  children: React.ReactNode
  image: string
  imageAlt: string
  reverse?: boolean
  smallPadding?: boolean
  largerImage?: boolean
}

const SplitCallout: React.FC<SplitCalloutProps> = ({
  additionalClasses,
  children,
  image,
  imageAlt,
  reverse,
  smallPadding,
  largerImage,
}) => {
  return (
    <div
      className={`${
        smallPadding ? 'mt-[1px]' : ' mt-[98px] md:mt-[92px]'
      } SplitCallout ${additionalClasses ? additionalClasses : ''}`}
    >
      <div className="mx-auto px-[4vw] lg:px-0 lg:mx-16 xl:mx-[5.9rem] flex items-center xl:items-start justify-center rounded-md lg:max-h-[871px] max-w-[825px] lg:max-w-[1200px] lg:bg-white flex-col lg:grid lg:grid-cols-2 overflow-clip">
        <div
          className={`${reverse ? 'lg:order-2' : ''} ${
            largerImage ? 'h-[77vw] xl:h-full' : 'h-[58vw]'
          } w-full  lg:col-span-1 rounded-t lg:rounded-none `}
        >
          <img
            src={image}
            alt={imageAlt}
            className={` lg:mt-0 w-full h-full object-[center_23%] object-cover xl:object-scale-down xl:object-top rounded-t-md ${
              reverse
                ? 'lg:rounded-r-md lg:rounded-tl-none '
                : 'lg:rounded-l-md lg:rounded-tr-none'
            } `}
          />
        </div>

        <div
          className={` ${
            smallPadding
              ? ''
              : 'pt-[48px] pb-8 pl-[28px] pr-[32px] lg:px-6 py-[24px] xl:py-[20px]'
          } xl:mx-auto rounded-b-md lg:pt-0 flex flex-col w-full lg:col-span-1 xl:pl-[46px] xl:pr-[50px] justify-center bg-white`}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default SplitCallout
